import { useMemo } from 'react'
import { useForm, Controller } from 'react-hook-form'
import * as Yup from 'yup'
import { useTranslation } from 'react-i18next'
import { yupResolver } from '@hookform/resolvers/yup'

export const initialValues = {
  name: '',
  sex: '',
  genre_type: '',
}

const useFormGenre = () => {
  const { t } = useTranslation()
  const validationSchema = useMemo(
    () =>
      Yup.object().shape({
        name: Yup.string()
          .max(
            100,
            t('SYSCOMMON.ERROR.E000007', {
              field: t('SYSCOMMON.name'),
              character: 100,
            })
          )
          .required(),
        sex: Yup.number().required().positive().integer(),
        genre_type: Yup.number().required().positive().integer(),
      }),
    []
  )

  const methods = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: initialValues,
    mode: 'onBlur',
  })

  return { Controller, methods, initialValues }
}

export default useFormGenre
